.container {
  padding: 0;

  select:disabled {
    opacity: 0.5;
  }
}

// The DSL "double input" chains its two dropdowns 12 apart; the selector carries
// the form foundation prefix to outrank its generic 8 for sibling selects.
:global(.form .field .input) .container select + select {
  margin-top: 12px;
}
